(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blc-cart-sticky-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const form = document.querySelector('[data-main-discount-section-id]');
    if (!form || form.dataset.blcCheckoutReady) return;
    form.dataset.blcCheckoutReady = 'true';
    const media = matchMedia('(max-width: 767px)');
    let scheduled = false;
    let observedBar;
    const resize = new ResizeObserver(schedule);
    function sync() {
      scheduled = false;
      const bar = form.querySelector('.blc-cart-checkout');
      const price = bar?.querySelector('[data-blc-cart-subtotal]');
      const subtotal = form.querySelector('[data-cart-prices] .t4s-cart__totalPrice');
      if (price && subtotal && price.textContent !== subtotal.textContent.trim()) price.textContent = subtotal.textContent.trim();
      if (bar !== observedBar) {
        resize.disconnect();
        if (bar) resize.observe(bar);
        observedBar = bar;
      }
      if (media.matches && bar) document.body.style.setProperty('--blc-cart-checkout-space', Math.ceil(bar.getBoundingClientRect().height + 12) + 'px');
      else document.body.style.removeProperty('--blc-cart-checkout-space');
    }
    function schedule() {
      if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
    }
    new MutationObserver(schedule).observe(form, { childList: true, characterData: true, subtree: true });
    addEventListener('resize', schedule);
    media.addEventListener('change', schedule);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blc-purchase-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const template = document.querySelector('[data-blc-purchase-template]');
    if (!template || template.dataset.ready) return;
    template.dataset.ready = 'true';
    const form = template.closest('form');
    const info = template.closest('.t4s-product__info-container');
    if (!form || !info) return;
    const config = template.dataset;
    const floatingEnabled = config.floatingPurchase === 'true';
    const variantPrices = JSON.parse(config.variantPrices || '{}');
    const bar = template.content.firstElementChild.cloneNode(true);
    const button = bar.querySelector('button');
    const originalButton = form.querySelector('.t4s-product-form__submit');
    const mainSelect = form.querySelector('.t4s-product__select, input[name="id"]');
    if (!originalButton || !mainSelect) return;
    const reviewLabel = document.createElement('span');
    reviewLabel.className = 'blc-main-review-label';
    reviewLabel.textContent = config.reviewEngraving;
    originalButton.append(reviewLabel);
    if (floatingEnabled) document.body.append(bar);
    const media = window.matchMedia('(max-width: 767px)');
    const widgetSelector = 'lb-product-page-cross-sell-ew';
    let scheduled = false;
    let changing = false;
    let pendingClick = false;
    let pendingPersonalization = false;
    const originalNames = new WeakMap();
    const originalLabels = new WeakMap();
    const setText = (node, value) => {
      if (!node || node.textContent === value) return;
      if (node.childNodes.length === 1 && node.firstChild.nodeType === Node.TEXT_NODE) node.firstChild.nodeValue = value;
      else node.textContent = value;
    };
    const variant = option => { try { return JSON.parse(option?.value || 'null'); } catch { return null; } };
    const qualifiesForShipping = (amount, currency, country) => currency === 'USD' && country === 'US' && Number.isFinite(amount) && Math.round(amount * 100) >= 9900;
    const shortName = name => {
      if (/keychain/i.test(name)) return config.keychain;
      if (/ultra\s*slim/i.test(name)) return config.slim;
      if (/business\s*card\s*holder/i.test(name)) return config.cardholder;
      if (/classic\s*vertical\s*bifold/i.test(name)) return config.vertical;
      if (/classic\s*bifold/i.test(name)) return config.classic;
      return name;
    };
    const visible = element => {
      if (!element || !element.getClientRects().length) return false;
      const rect = element.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight && getComputedStyle(element).visibility !== 'hidden';
    };
    const syncBundle = widget => {
      if (changing) return;
      widget.querySelectorAll('.lb-shared-variants-select').forEach(select => {
        const options = [...select.options];
        if (!options.some(option => variant(option)?.isForProduct)) return;
        const match = options.find(option => {
          const data = variant(option);
          return data?.isForProduct && String(data.id) === mainSelect.value;
        });
        if (match && select.value !== match.value) {
          changing = true;
          try {
            select.value = match.value;
            select.dispatchEvent(new Event('change', {bubbles: true}));
          } finally { changing = false; }
        }
      });
    };
    const decorateBundle = widget => {
      syncBundle(widget);
      widget.querySelectorAll('.lb-spc-details-name').forEach(node => {
        const current = node.textContent.trim();
        let saved = originalNames.get(node);
        if (!saved || (current !== saved.short && current !== saved.full)) {
          saved = {full: current, short: shortName(current)};
          originalNames.set(node, saved);
        }
        if (saved.full !== saved.short) {
          if (node.title !== saved.full) node.title = saved.full;
          setText(node, saved.short);
        }
        const card = node.closest('lb-product-card');
        const checkbox = card?.querySelector('.lb-spc-details-checkbox');
        if (checkbox && checkbox.getAttribute('aria-label') !== saved.short) checkbox.setAttribute('aria-label', saved.short);
      });
      const cta = widget.querySelector('.lb-upsell-tot-btn');
      const price = widget.querySelector('.ppcse-card-tot-price .money');
      if (!cta || !price) return;
      const selectedCards = [...widget.querySelectorAll('lb-product-card')].filter(card => card.querySelector('.lb-spc-details-checkbox')?.checked);
      const count = selectedCards.length;
      const compare = widget.querySelector('.ppcse-card-tot-price-strike-out .money');
      let sale = Number(price.getAttribute('default-price'));
      const was = Number(compare?.getAttribute('default-price'));
      const currency = config.currency || 'USD';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency});
      const rate = Number(widget.querySelector('.ppcse-offer-desc')?.textContent.match(/(\d+(?:\.\d+)?)\s*%/)?.[1]);
      const cents = selectedCards.map(card => Math.round(Number(card.querySelector('.lb-spc-details-price .money')?.getAttribute('default-price')) * 100));
      const totalCents = cents.reduce((sum, value) => sum + value, 0);
      const hasTrigger = selectedCards.some(card => card.querySelector('.lb-spc-details-name.lb-spc-pointer-events-none') || [...card.querySelectorAll('.lb-shared-variants-select option')].some(option => variant(option)?.isForProduct));
      if (currency === 'USD' && rate === 10 && hasTrigger && count > 1 && cents.every(value => value > 0) && totalCents === Math.round(was * 100) && Math.abs(Math.round(sale * 100) - Math.ceil(totalCents * .9)) <= 1) {
        sale = cents.reduce((sum, value) => sum + value - Math.floor(value / 10), 0) / 100;
      }
      if (price.hasAttribute('default-price') && Number.isFinite(sale)) setText(price, formatter.format(sale));
      let labelNode = [...cta.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
      if (!labelNode) return;
      if (!originalLabels.has(cta)) originalLabels.set(cta, labelNode.textContent);
      const label = count > 0 ? `${(count === 1 ? config.addOne : config.addMany).replace('[count]', String(count))} — ${price.textContent.trim()}` : originalLabels.get(cta);
      if (labelNode.textContent !== label) labelNode.textContent = label;
      if (!cta.hasAttribute('role')) cta.setAttribute('role', 'button');
      if (!cta.hasAttribute('tabindex')) cta.setAttribute('tabindex', '0');
      if (!cta.dataset.blcKeyboard) {
        cta.dataset.blcKeyboard = 'true';
        cta.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); cta.click(); }
        });
      }
      const savings = Math.round((was - sale) * 100) / 100;
      const messages = [];
      if (savings > 0 && count > 1 && Number.isFinite(savings)) messages.push(`${config.save} ${formatter.format(savings)}`);
      if (count > 0 && qualifiesForShipping(sale, currency, config.country)) messages.push(config.shippingUnlocked);
      let note = widget.querySelector('.blc-bundle-savings');
      if (messages.length) {
        if (!note) {
          note = document.createElement('p');
          note.className = 'blc-bundle-savings';
          cta.parentElement.append(note);
        }
        setText(note, messages.join(' · '));
      } else if (note) note.remove();
    };
    const updateBar = () => {
      const editorSelection = document.querySelector('.pplr-popup [name="properties[Personalization]"]');
      if (editorSelection) pendingPersonalization = !!editorSelection.value && editorSelection.value !== 'None';
      originalButton.classList.toggle('blc-review-engraving', pendingPersonalization);
      const quantity = form.querySelector('[name="quantity"]')?.value || '1';
      const heading = info.querySelector('h1')?.textContent.trim() || document.querySelector('h1')?.textContent.trim() || '';
      const selected = mainSelect.selectedOptions?.[0]?.textContent.trim();
      setText(bar.querySelector('[data-blc-product-name]'), shortName(heading));
      const details = [selected && selected !== 'Default Title' ? selected : '', `${config.quantity} ${quantity}`, pendingPersonalization ? config.engraving : ''].filter(Boolean).join(' · ');
      setText(bar.querySelector('[data-blc-selection]'), details);
      const personalization = form.querySelector('[name="properties[Personalization]"]');
      const hasPersonalization = personalization && personalization.value && personalization.value !== 'None';
      const basePrice = variantPrices[mainSelect.value];
      const amount = Number.isFinite(basePrice) && !hasPersonalization ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: config.currency || 'USD'}).format(basePrice * Number(quantity) / 100) : form.querySelector('.zdzppph')?.textContent.trim() || '';
      setText(bar.querySelector('[data-blc-price]'), pendingPersonalization ? '' : amount);
      button.disabled = pendingClick || originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true' || originalButton.classList.contains('is--loading');
      const labelContent = originalButton.querySelector('.t4s-btn-atc_text')?.cloneNode(true);
      labelContent?.querySelectorAll('.blc-atc-price').forEach(price => price.remove());
      const label = labelContent?.textContent.trim();
      if (label) setText(button.firstElementChild, pendingPersonalization ? config.reviewEngraving : label);
      const rect = originalButton.getBoundingClientRect();
      const bundleVisible = [...document.querySelectorAll(widgetSelector)].some(visible);
      const overlay = !!document.querySelector('.t4s-drawer[aria-hidden="false"]') || document.body.classList.contains('pplr_fixed') || document.body.classList.contains('pplr_fixed_cropper') || [...document.querySelectorAll('[aria-modal="true"], .pplr-modal-overlay, .t4s-modal__inner')].some(visible);
      const editing = document.activeElement?.matches('input:not([type="checkbox"]):not([type="radio"]), textarea, select, [contenteditable="true"]');
      const mainButtonOutsideViewport = rect.top >= window.innerHeight || rect.bottom <= 0;
      const show = floatingEnabled && media.matches && mainButtonOutsideViewport && !bundleVisible && !overlay && !editing;
      if (bar.hidden === show) bar.hidden = !show;
      document.body.classList.toggle('blc-sticky-active', show);
      if (show) {
        const space = `${Math.ceil(bar.getBoundingClientRect().height)}px`;
        if (document.body.style.getPropertyValue('--blc-sticky-space') !== space) document.body.style.setProperty('--blc-sticky-space', space);
      }
    };
    const refresh = () => {
      scheduled = false;
      document.querySelectorAll(widgetSelector).forEach(decorateBundle);
      updateBar();
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } };
    const settle = () => { schedule(); window.setTimeout(schedule, 100); window.setTimeout(schedule, 350); };
    document.addEventListener('change', event => {
      const select = event.target.closest?.(`${widgetSelector} .lb-shared-variants-select`);
      const data = select ? variant(select.selectedOptions[0]) : null;
      if (!changing && data?.isForProduct && String(data.id) !== mainSelect.value) {
        const option = [...(mainSelect.options || [])].find(item => item.value === String(data.id));
        const swatch = [...form.querySelectorAll('.t4s-swatch__item')].find(item => item.getAttribute('data-value') === option?.textContent.trim());
        if (swatch) swatch.click();
      }
      settle();
    });
    form.addEventListener('click', settle);
    form.addEventListener('input', schedule);
    const reviewMainEngraving = event => {
      updateBar();
      const editorButton = form.querySelector('.pplr-c-button');
      if (!pendingPersonalization || !editorButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      editorButton.click();
      settle();
    };
    document.addEventListener('click', event => {
      if (originalButton.contains(event.target)) reviewMainEngraving(event);
    }, true);
    form.addEventListener('submit', reviewMainEngraving, true);
    button.addEventListener('click', () => {
      if (button.disabled) return;
      if (pendingPersonalization) {
        const editorButton = form.querySelector('.pplr-c-button');
        if (editorButton) { editorButton.click(); settle(); return; }
      }
      pendingClick = true;
      updateBar();
      if (!form.checkValidity()) {
        originalButton.scrollIntoView({block: 'center', behavior: 'smooth'});
        form.reportValidity();
      } else originalButton.click();
      window.setTimeout(() => { pendingClick = false; schedule(); }, 1500);
    });
    const observer = new MutationObserver(records => {
      if (records.some(record => !bar.contains(record.target))) schedule();
    });
    observer.observe(info, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled', 'value', 'checked', 'default-price']});
    new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class']});
    new MutationObserver(schedule).observe(document.body, {subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'aria-modal']});
    new MutationObserver(schedule).observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    media.addEventListener('change', schedule);
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
